/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyImageResponseDto } from './PropertyImageResponseDto';
import {
    PropertyImageResponseDtoFromJSON,
    PropertyImageResponseDtoFromJSONTyped,
    PropertyImageResponseDtoToJSON,
    PropertyImageResponseDtoToJSONTyped,
} from './PropertyImageResponseDto';
import type { ListingAgentDto } from './ListingAgentDto';
import {
    ListingAgentDtoFromJSON,
    ListingAgentDtoFromJSONTyped,
    ListingAgentDtoToJSON,
    ListingAgentDtoToJSONTyped,
} from './ListingAgentDto';
import type { RecurringCostItemDto } from './RecurringCostItemDto';
import {
    RecurringCostItemDtoFromJSON,
    RecurringCostItemDtoFromJSONTyped,
    RecurringCostItemDtoToJSON,
    RecurringCostItemDtoToJSONTyped,
} from './RecurringCostItemDto';
import type { HoaFeeDto } from './HoaFeeDto';
import {
    HoaFeeDtoFromJSON,
    HoaFeeDtoFromJSONTyped,
    HoaFeeDtoToJSON,
    HoaFeeDtoToJSONTyped,
} from './HoaFeeDto';

/**
 * 
 * @export
 * @interface PropertyDto
 */
export interface PropertyDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    mlsId?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    mlsSource?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    addressLine1?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    addressLine2?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    area?: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    baths?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    beds?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    listingStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    buildingName?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    garageSpaces?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    hoaFees?: number;
    /**
     * 
     * @type {HoaFeeDto}
     * @memberof PropertyDto
     */
    hoaFee?: HoaFeeDto | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    floor?: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyDto
     */
    listDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    listPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    livingSpace?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    lotSize?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    neighborhood?: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    nonGarageSpaces?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     * @deprecated
     */
    propertyStyle?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PropertyDto
     */
    propertyStyles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    propertyStyleOther?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     * @deprecated
     */
    propertyType?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    propertyTypeOther?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    propertyTypeRaw?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    propertySubTypeRaw?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    state?: string;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    yearBuilt?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    renovationType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDto
     */
    hasAdditionalLivingSpace?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    additionalLivingSpaceSqFt?: number;
    /**
     * 
     * @type {Array<PropertyImageResponseDto>}
     * @memberof PropertyDto
     */
    images: Array<PropertyImageResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    soldPrice?: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyDto
     */
    soldDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    county?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDto
     */
    smartResult?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDto
     */
    hasDoormanAttendance: boolean;
    /**
     * 
     * @type {ListingAgentDto}
     * @memberof PropertyDto
     */
    listingAgent: ListingAgentDto;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDto
     */
    isLease?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    roomsTotal?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDto
     */
    flipTaxRemarks?: string;
    /**
     * 
     * @type {Array<RecurringCostItemDto>}
     * @memberof PropertyDto
     */
    recurringCosts?: Array<RecurringCostItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PropertyDto
     */
    cumulativeDaysOnMarket?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PropertyDto
     */
    originatingSystemModificationTimestamp?: Date | null;
}

/**
 * Check if a given object implements the PropertyDto interface.
 */
export function instanceOfPropertyDto(value: object): value is PropertyDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('hasDoormanAttendance' in value) || value['hasDoormanAttendance'] === undefined) return false;
    if (!('listingAgent' in value) || value['listingAgent'] === undefined) return false;
    return true;
}

export function PropertyDtoFromJSON(json: any): PropertyDto {
    return PropertyDtoFromJSONTyped(json, false);
}

export function PropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mlsId': json['mlsId'] == null ? undefined : json['mlsId'],
        'mlsSource': json['mlsSource'] == null ? undefined : json['mlsSource'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'area': json['area'] == null ? undefined : json['area'],
        'baths': json['baths'] == null ? undefined : json['baths'],
        'beds': json['beds'] == null ? undefined : json['beds'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'listingStatus': json['listingStatus'] == null ? undefined : json['listingStatus'],
        'buildingName': json['buildingName'] == null ? undefined : json['buildingName'],
        'city': json['city'] == null ? undefined : json['city'],
        'description': json['description'] == null ? undefined : json['description'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'garageSpaces': json['garageSpaces'] == null ? undefined : json['garageSpaces'],
        'hoaFees': json['hoaFees'] == null ? undefined : json['hoaFees'],
        'hoaFee': json['hoaFee'] == null ? undefined : HoaFeeDtoFromJSON(json['hoaFee']),
        'floor': json['floor'] == null ? undefined : json['floor'],
        'listDate': json['listDate'] == null ? undefined : (new Date(json['listDate'])),
        'listPrice': json['listPrice'] == null ? undefined : json['listPrice'],
        'livingSpace': json['livingSpace'] == null ? undefined : json['livingSpace'],
        'lotSize': json['lotSize'] == null ? undefined : json['lotSize'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'nonGarageSpaces': json['nonGarageSpaces'] == null ? undefined : json['nonGarageSpaces'],
        'propertyStyle': json['propertyStyle'] == null ? undefined : json['propertyStyle'],
        'propertyStyles': json['propertyStyles'] == null ? undefined : json['propertyStyles'],
        'propertyStyleOther': json['propertyStyleOther'] == null ? undefined : json['propertyStyleOther'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'propertyTypeOther': json['propertyTypeOther'] == null ? undefined : json['propertyTypeOther'],
        'propertyTypeRaw': json['propertyTypeRaw'] == null ? undefined : json['propertyTypeRaw'],
        'propertySubTypeRaw': json['propertySubTypeRaw'] == null ? undefined : json['propertySubTypeRaw'],
        'state': json['state'] == null ? undefined : json['state'],
        'yearBuilt': json['yearBuilt'] == null ? undefined : json['yearBuilt'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'renovationType': json['renovationType'] == null ? undefined : json['renovationType'],
        'hasAdditionalLivingSpace': json['hasAdditionalLivingSpace'] == null ? undefined : json['hasAdditionalLivingSpace'],
        'additionalLivingSpaceSqFt': json['additionalLivingSpaceSqFt'] == null ? undefined : json['additionalLivingSpaceSqFt'],
        'images': ((json['images'] as Array<any>).map(PropertyImageResponseDtoFromJSON)),
        'soldPrice': json['soldPrice'] == null ? undefined : json['soldPrice'],
        'soldDate': json['soldDate'] == null ? undefined : (new Date(json['soldDate'])),
        'county': json['county'] == null ? undefined : json['county'],
        'smartResult': json['smartResult'] == null ? undefined : json['smartResult'],
        'hasDoormanAttendance': json['hasDoormanAttendance'],
        'listingAgent': ListingAgentDtoFromJSON(json['listingAgent']),
        'isLease': json['isLease'] == null ? undefined : json['isLease'],
        'roomsTotal': json['roomsTotal'] == null ? undefined : json['roomsTotal'],
        'flipTaxRemarks': json['flipTaxRemarks'] == null ? undefined : json['flipTaxRemarks'],
        'recurringCosts': json['recurringCosts'] == null ? undefined : ((json['recurringCosts'] as Array<any>).map(RecurringCostItemDtoFromJSON)),
        'cumulativeDaysOnMarket': json['cumulativeDaysOnMarket'] == null ? undefined : json['cumulativeDaysOnMarket'],
        'originatingSystemModificationTimestamp': json['originatingSystemModificationTimestamp'] == null ? undefined : (new Date(json['originatingSystemModificationTimestamp'])),
    };
}

export function PropertyDtoToJSON(json: any): PropertyDto {
    return PropertyDtoToJSONTyped(json, false);
}

export function PropertyDtoToJSONTyped(value?: PropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'area': value['area'],
        'baths': value['baths'],
        'beds': value['beds'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'listingStatus': value['listingStatus'],
        'buildingName': value['buildingName'],
        'city': value['city'],
        'description': value['description'],
        'notes': value['notes'],
        'garageSpaces': value['garageSpaces'],
        'hoaFees': value['hoaFees'],
        'hoaFee': HoaFeeDtoToJSON(value['hoaFee']),
        'floor': value['floor'],
        'listDate': value['listDate'] == null ? undefined : ((value['listDate']).toISOString()),
        'listPrice': value['listPrice'],
        'livingSpace': value['livingSpace'],
        'lotSize': value['lotSize'],
        'neighborhood': value['neighborhood'],
        'nonGarageSpaces': value['nonGarageSpaces'],
        'propertyStyle': value['propertyStyle'],
        'propertyStyles': value['propertyStyles'],
        'propertyStyleOther': value['propertyStyleOther'],
        'propertyType': value['propertyType'],
        'propertyTypeOther': value['propertyTypeOther'],
        'propertyTypeRaw': value['propertyTypeRaw'],
        'propertySubTypeRaw': value['propertySubTypeRaw'],
        'state': value['state'],
        'yearBuilt': value['yearBuilt'],
        'zipCode': value['zipCode'],
        'renovationType': value['renovationType'],
        'hasAdditionalLivingSpace': value['hasAdditionalLivingSpace'],
        'additionalLivingSpaceSqFt': value['additionalLivingSpaceSqFt'],
        'images': ((value['images'] as Array<any>).map(PropertyImageResponseDtoToJSON)),
        'soldPrice': value['soldPrice'],
        'soldDate': value['soldDate'] == null ? undefined : ((value['soldDate']).toISOString()),
        'county': value['county'],
        'smartResult': value['smartResult'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'listingAgent': ListingAgentDtoToJSON(value['listingAgent']),
        'isLease': value['isLease'],
        'roomsTotal': value['roomsTotal'],
        'flipTaxRemarks': value['flipTaxRemarks'],
        'recurringCosts': value['recurringCosts'] == null ? undefined : ((value['recurringCosts'] as Array<any>).map(RecurringCostItemDtoToJSON)),
        'cumulativeDaysOnMarket': value['cumulativeDaysOnMarket'],
        'originatingSystemModificationTimestamp': value['originatingSystemModificationTimestamp'] === null ? null : ((value['originatingSystemModificationTimestamp'] as any)?.toISOString()),
    };
}

